// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryAd2-cls1_-8i","cls2":"PodcastLibraryAd2-cls2_iVF PodcastLibraryAd2-cls1_-8i"};